// @generated by protoc-gen-connect-query v2.3.1 with parameter "target=ts"
// @generated from file travplaces/v1/category.proto (package travplaces.v1, syntax proto3)
/* eslint-disable */

import { CategoryService } from "./category_pb";

/**
 * ListCategories returns all categories in display order.
 *
 * @generated from rpc travplaces.v1.CategoryService.ListCategories
 */
export const listCategories = CategoryService.method.listCategories;
